import { memo } from 'react'

const SearchBox = ({ title, placeholder, value, onChanged, className, isRound = true, fullHeight = false } : 
  { title? : string, placeholder? : string, value: string, 
    onChanged : (value: string) => void, className?: string, isRound?: boolean, fullHeight?: boolean }) => <div className={className || ''}>
  <small className={`text-muted${title ? '':' hidden'}`}>{title}</small>
  <div className={`relative${fullHeight ? ' h-full' : ''}`}>
    <span className="absolute inset-y-0 left-0 flex items-center pl-2">
      <svg fill="none" stroke="hsl(0deg 0% 50%)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-5 h-5 ml-1.5"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
    </span>
    <input type="search" className={`${fullHeight ? 'h-full ' : ''}pl-10 input-form-text ${isRound ? 'rounded-full': ''}`}
      placeholder={placeholder ? placeholder : "Search..."}
      value={value} onChange={(e) => onChanged(e.currentTarget.value)}/>
  </div>
</div>

export default memo(SearchBox)